const Table = ({ title, head, rows, testId }) => (
  <div className="mb-12" data-testid={testId}>
    <h3 className="font-display text-2xl text-[var(--g-dark,#3B1B48)] mb-4">{title}</h3>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead><tr>{head.map((h) => <th key={h} className="text-left eyebrow !text-[var(--g-dark,#3B1B48)] border-b border-[var(--g-dark,#3B1B48)] py-3 pr-4">{h}</th>)}</tr></thead>
        <tbody>{rows.map((r, i) => <tr key={i} className="border-b border-[#E2D9CC]">{r.map((cell, j) => <td key={j} className="py-3 pr-4 align-top">{cell}</td>)}</tr>)}</tbody>
      </table>
    </div>
  </div>
);

export const ToolkitPanel = ({ c, rate }) => (
  <div>
    <Table testId="costs-table" title="Cost of living" head={["Item", "Frequency", "EUR", "≈ AUD"]}
      rows={(c.costs || []).map((k) => [k.item, k.frequency, `€${k.eur_low}–${k.eur_high}`, `A$${Math.round(k.eur_low * rate)}–${Math.round(k.eur_high * rate)}`])} />
    <Table testId="visas-table" title="Visas & residency" head={["Pathway", "Who", "Requirement", "Notes"]}
      rows={(c.visas || []).map((v) => [<b key="p" className="text-[var(--g-dark,#3B1B48)]">{v.pathway}</b>, v.who, v.requirement, v.notes])} />
    <Table testId="nearby-table" title="Beyond the town" head={["Place", "Distance", "Travel", "Why"]}
      rows={(c.nearby || []).map((n) => [n.place, `${n.distance_km} km`, n.travel_time, n.why])} />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
      <Table testId="checklist-table" title="Move checklist" head={["Phase", "Task"]} rows={(c.checklist || []).map((t) => [t.phase, t.task])} />
      <Table testId="worksheet-table" title="Decision worksheet" head={["Question", "Weight"]} rows={(c.worksheet || []).map((q) => [q.question, `× ${q.weight}`])} />
    </div>
  </div>
);

export const SourcesPanel = ({ c }) => (
  <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-12">
    <div data-testid="sources-list">
      <h3 className="font-display text-2xl text-[var(--g-dark,#3B1B48)] mb-4">Research sources</h3>
      {(c.sources || []).map((s, i) => (
        <a key={`${s.url}-${i}`} href={s.url} target="_blank" rel="noreferrer" className="block py-3 border-b border-[#E2D9CC] hover:bg-[var(--g-mist,#EFE6F3)] transition-colors">
          <span className="eyebrow">{s.label}</span>
          <span className="block text-sm text-[var(--g-dark,#3B1B48)] break-all">{s.title}</span>
          <span className="block text-xs text-[#8C827A] break-all">{s.url}</span>
        </a>
      ))}
    </div>
    <div>
      <h3 className="font-display text-2xl text-[var(--g-dark,#3B1B48)] mb-4">Verified facts (Wikidata)</h3>
      <dl data-testid="verified-facts">
        {Object.entries(c.facts || {}).map(([k, v]) => (
          <div key={k} className="flex justify-between gap-4 py-3 border-b border-[#E2D9CC] text-sm">
            <dt className="eyebrow !text-[#8C827A]">{k.replace(/_/g, " ")}</dt><dd className="text-right break-all">{String(v)}</dd>
          </div>
        ))}
      </dl>
      <h3 className="font-display text-2xl text-[var(--g-dark,#3B1B48)] mt-10 mb-4">Directory</h3>
      {(c.directory || []).map((d) => (
        <p key={d.name + d.url} className="text-sm py-2 border-b border-[#E2D9CC]">
          <b className="text-[var(--g-dark,#3B1B48)]">{d.name}</b> <span className="text-[#8C827A]">· {d.category}</span><br />
          <a href={d.url} target="_blank" rel="noreferrer" className="text-xs text-[var(--g-dark2,#4A1E5C)] break-all hover:underline">{d.url}</a>
        </p>
      ))}
    </div>
  </div>
);
